export default class ControlConstants {
    public static PLAYER_WALK_SPEED = 0.5;
    public static PLAYER_RUN_SPEED = 1.5;
    public static PLAYER_ROTATION_SPEED = 0.2;
    public static PLAYER_MOVEMENT_DAMPING = 1;
    public static PLAYER_ROTATION_DAMPING = 1;

    public static ORBIT_Y_LIMIT = Math.PI / 2 - 0.1;
    public static ORBIT_SENSITIVITY = 5;
}
